import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { productSizingVideo } from '../../../analytics';

const YouTubeVideo = (props) => {
  const { id, title } = props;
  const iframeStyles = { border: 'none', position: 'absolute' };
  let prevEvent = -1;

  const setPrevEvent = (event) => {
    prevEvent = event;
  };

  const onPlayerStateChange = (event) => {
    const VIDEO_PLAYED = 'play sizing video';
    const VIDEO_ENDED = 'complete sizing video';

    switch (event.data) {
      case 1: {
        if (prevEvent !== 0) productSizingVideo(VIDEO_PLAYED);
        break;
      }
      case 0: {
        productSizingVideo(VIDEO_ENDED);
        break;
      }
      default: {
        break;
      }
    }

    setPrevEvent(event.data);
  };

  const loadVideo = () => {
    // eslint-disable-next-line no-unused-vars
    const player = new window.YT.Player(`youtube-player-${id}`, {
      videoId: id,
      title: title,
      width: '100%',
      height: '100%',
      playerVars: {
        frameBorder: '0',
        allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
      },
      events: {
        onStateChange: onPlayerStateChange
      }
    });
  };

  useEffect(() => {
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';

      // onYouTubeIframeAPIReady will load the video after the script is loaded
      window.onYouTubeIframeAPIReady = loadVideo;

      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    } else {
      loadVideo();
    }
  }, []);

  return (
    <div id={`youtube-player-${id}`} style={iframeStyles} />
  );

};

YouTubeVideo.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string
};

YouTubeVideo.defaultProps = {
  title: ''
};

export default YouTubeVideo;
